<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <v-expansion-panels
      v-model="panel"
      class="app-expansion-panels"
    >
      <v-expansion-panel @click.stop="changeCollapse">
        <v-expansion-panel-header class="app-expansion-panel-header mb-0">
          <h4 class="text">
            <v-icon>filter_alt</v-icon>
            <span>Filtrar Pedidos</span>
          </h4>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="app-expansion-panel-content">
          <v-row class="mt-3">
            <v-col
              :lg="4"
              :md="4"
              :sm="6"
              :xs="12"
            >
              <v-text-field
                v-model="table.paginate.input.id"
                :clearable="true"
                label="Número Pedido"
                placeholder="Ex:. 12345"
                outlined
                dense
              />
            </v-col>
            <v-col
              :lg="4"
              :md="4"
              :sm="6"
              :xs="12"
            >
              <v-text-field
                v-model="
                  table.paginate.input.veiculoTransportadora.veiculo.placa
                "
                :clearable="true"
                label="Placa Veículo"
                placeholder="Ex:. PCN4566"
                outlined
                dense
              />
            </v-col>
            <v-col
              :lg="4"
              :md="4"
              :sm="6"
              :xs="12"
            >
              <v-select
                v-model="table.paginate.input.tipoPedido"
                :items="tipoPedido"
                :item-text="v => v[1]"
                :item-value="v => v[0]"
                :clearable="true"
                label="Escolha o tipo de pedido"
                single-line
                outlined
                dense
              />
            </v-col>
            <v-col
              :lg="4"
              :md="4"
              :sm="6"
              :xs="12"
              class="pt-0"
            >
              <v-select
                v-model="table.paginate.input.statuses"
                :items="statusPedido"
                :item-text="v => v[1]"
                :item-value="v => v[0]"
                :clearable="true"
                label="Escolha o status do pedido"
                single-line
                outlined
                dense
              />
            </v-col>
            <!-- <v-col :lg="4" :md="4" :sm="12" :xs="12" class="pt-0">
              <v-menu
                ref="dateCriacaoMenu"
                v-model="dateCriacaoMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="table.paginate.input.dataCriacao"
                    clearable
                    label="Data Criação"
                    placeholder="Selecione uma data"
                    prepend-inner-icon="date_range"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateCriacao">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateCriacaoMenu = false">Cancelar</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      $refs.dateCriacaoMenu.save(
                        table.paginate.input.dataCriacao
                      )
                    "
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>-->
          </v-row>
          <v-divider />
          <div class="mt-3 d-flex">
            <v-spacer />
            <v-btn
              outlined
              color="error"
              type="button"
              class="mr-2"
              @click.prevent.stop="clearFilter"
            >
              <v-icon size="14">
                delete
              </v-icon>Limpar Filtros
            </v-btn>
            <v-btn
              depressed
              color="primary"
              type="submit"
            >
              Filtrar
            </v-btn>
          </div>

          <section
            v-if="table.isLoading"
            class="loading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </section>
          <div id="endForm" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TipoPedidoEnum } from "@/models/sit-pedido/tipo-pedido.enum";
import { StatusPedidoEnum } from "@/models/sit-pedido/status-pedido.enum";
import dayjs from "dayjs";
import PedidoService from '@/services/sit-pedidos/pedido.service'

// Vuex Store - Sit Pedidos (mapping actions and states)
const actions = mapActions('sitPedidos', ['setTableContent', 'setTableIsLoading', 'setTableTotals', 'clearTable',])
const state = mapState('sitPedidos', ['table'])

export default {
  data: () => ({
    panel: null,
    tipoPedido: Object.entries(TipoPedidoEnum),
    statusPedido: Object.entries(StatusPedidoEnum),
    dateCriacaoMenu: false,
    dateCriacao: null
  }),
  computed: {
    ...state
  },
  watch: {
    dateCriacao(value) {
      if (!value) return;

      this.table.paginate.input.dataCriacao = dayjs(value, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
    }
  },
  methods: {
    async onSubmit() {
      await this.search();
      this.$vuetify.goTo("#endForm");
    },
    clearFilter() {
      this.clearTable();
      this.search();
    },
    changeCollapse() {},
    search() {
      this.setTableIsLoading(true)
      PedidoService.page(this.table.paginate).subscribe(({content, totalElements})=>{
        this.setTableContent(content)
        this.setTableTotals(totalElements)
        this.setTableIsLoading(false)
      }, (error)=>{
        this.setTableIsLoading(false)
      })
    },
    ...actions
  },
};
</script>
